import './logo-slider.scss'
import { gsap } from "gsap";

document.addEventListener('DOMContentLoaded', () => {
	const logoSliders = document.querySelectorAll('.js-logoSlider');

	logoSliders.forEach((slider) => {
		if (slider.dataset.marqueeInitialized === '1') {
			return;
		}

		const track = slider.querySelector('.js-slider');
		if (!track) {
			return;
		}

		// configurable speed (seconds to traverse one original track width). Override via data-speed
		const speed = Number(slider.getAttribute('data-speed')) || 12;

		// duplicate the entire track right after the original to enable seamless looping
		const clone = track.cloneNode(true);
		clone.setAttribute('aria-hidden', 'true');
		clone.classList.add('-clone');
		slider.appendChild(clone);

		// add a second clone to avoid gaps on very wide viewports
		const clone2 = track.cloneNode(true);
		clone2.setAttribute('aria-hidden', 'true');
		clone2.classList.add('-clone2');
		slider.appendChild(clone2);

		// ensure items do not wrap
		slider.style.flexWrap = 'nowrap';

		// pause/resume on hover
		slider.addEventListener('mouseenter', () => { slider._marqueeTween?.pause?.(); });
		slider.addEventListener('mouseleave', () => { slider._marqueeTween?.resume?.(); });

		function startMarquee() {
			// kill previous tween if any
			if (slider._marqueeTween) {
				slider._marqueeTween.kill();
				slider._marqueeTween = null;
			}

			// width of a single track
			const singleWidth = track.scrollWidth;
			// set container width to the sum of both tracks
			slider.style.width = (singleWidth * 2) + 'px';

			// animate from 0 to -singleWidth px for a seamless loop over the doubled content
			slider._marqueeTween = gsap.fromTo(
				slider,
				{ x: 0 },
				{
					x: -singleWidth,
					duration: speed,
					ease: 'none',
					repeat: -1,
					onRepeat() { gsap.set(slider, { x: 0 }); }
				}
			);
		}

		// wait for images to load before measuring widths
		const imgs = slider.querySelectorAll('img');
		let pending = 0;
		function done() { if (--pending <= 0) { startMarquee(); } }
		imgs.forEach((img) => {
			if (!img.complete) {
				pending++;
				img.addEventListener('load', done, { once: true });
				img.addEventListener('error', done, { once: true });
			}
		});
		if (pending === 0) {
			startMarquee();
		}

		// re-calc on resize
		window.addEventListener('resize', startMarquee);

		slider.dataset.marqueeInitialized = '1';
	});

});